/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：18
 */

"use strict"

var r
var o
var i
var a
var s
var c
var l
var u
var d
var p
export { r as e }
export { i as f }
export { a as h }
export { s as d }
export { c as g }
export { l as a }
export { u as b }
export { d as i }
export { p as c }
export { __WITHOUT_FOCUS__ as k }
export { f as j };
(function (e) {
  e.camera = "camera"
  e.microphone = "microphone"
})(r || (r = {}));
(function (e) {
  e.IMAGE_LIST = "IMAGE_LIST"
})(o || (o = {}));
(function (e) {
  e[e.MY_PROJECT = 0] = "MY_PROJECT"
  e[e.CREATE_PROJECT = 1] = "CREATE_PROJECT"
})(i || (i = {}));
(function (e) {
  e.DevTools = "DevTools"
  e.ResourceLayout = "ResourceLayout"
})(a || (a = {}));
(function (e) {
  e.HOME_COURSE = "HOME_COURSE"
  e.HOME_TEMPLATE = "HOME_TEMPLATE"
  e.COURSE = "COURSE"
  e.TEMPLATE = "TEMPLATE"
  e.OTHER = "OTHER"
  e.MY_WORK = "MY_WORK"
  e.LOCAL_FILE = "LOCAL_FILE"
})(s || (s = {}));
(function (e) {
  e[e.FREEDOM = 1] = "FREEDOM"
  e[e.TEMPLATE = 2] = "TEMPLATE"
  e[e.COURSE = 3] = "COURSE"
  e[e.LOCAL = 4] = "LOCAL"
})(c || (c = {}));
(function (e) {
  e.DYNAMIC_DROPDOWN = "DYNAMIC_DROPDOWN"
  e.IMAGE_DROPDOWN = "IMAGE_DROPDOWN"
  e.ICON_DROPDOWN = "ICON_DROPDOWN"
  e.ACTOR_STYLE_DROPDOWN = "ACTOR_STYLE_DROPDOWN"
  e.SOUND_DROPDOWN = "SOUND_DROPDOWN"
  e.SCREEN_DROPDOWN = "SCREEN_DROPDOWN"
})(l || (l = {}));
(function (e) {
  e.PRIMITIVE = "PRIMITIVE"
  e.ARRAY = "ARRAY"
  e.BROADCAST = "BROADCAST"
  e.DOCUMENT_KEY = "DOCUMENT_KEY"
  e.CLOUD_DATA_KEY = "CLOUD_DATA_KEY"
  e.GRID = "GRID"
  e.OBJECT = "OBJECT"
  e.NONE = ""
})(u || (u = {}));
(function (e) {
  e.GLOBAL = "GLOBAL"
  e.SCREEN = "SCREEN"
})(d || (d = {}));
(function (e) {
  e[e.Edit = 1] = "Edit"
  e[e.ReadOnly = 2] = "ReadOnly"
  e[e.Preview = 3] = "Preview"
})(p || (p = {}))
var f
var /* [auto-meaningful-name] */__WITHOUT_FOCUS__ = "__WITHOUT_FOCUS__"
!function (e) {
  e[e.Show = 0] = "Show"
  e[e.Hide = 1] = "Hide"
  e[e.ReadOnly = 2] = "ReadOnly"
}(f || (f = {}))
export default l
